// Transforms a flat array of internal product definitions into a lookup map (Record) keyed by product name,
// while automatically injecting the brand property into each item.
export function buildProductRecord<TInternal extends { name: string }, TOutput>(
  rawData: TInternal[],
  brand: string
): Record<string, TOutput> {
  return rawData.reduce<Record<string, TOutput>>((accumulator, item) => {
    // Key each entry by product name, spread the original internal properties, and attach the brand name
    accumulator[item.name] = {
      ...item,
      brand,
    } as unknown as TOutput; // Double cast satisfies TS since TOutput adds the 'brand' field to TInternal
    return accumulator;
  }, {});
}
